import axios from "axios";

export async function getJobBenefitList({ limit, offset, name }) {
  const benefits = await axios.get("/benefits", {
    params: {
      limit,
      offset,
      name
    }
  });
  return benefits.data;
}

export const addBenefits = async (benefits) => {
  return await axios.post("/benefits/add-benefits", benefits);
};

export const deleteBenefits = async (benefitIds) => {
  console.log("🚀 ~ deleteBenefits ~ skillIds:", benefitIds);
  return await axios.delete("/benefits", { data: { benefitIds } });
};
